import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { BadgeProgress } from '../badge';
var Badge = t.type({
  id: t.string,
  name: t.string,
  imageUrl: t.string,
  description: t.string,
  level: nullable(t.type({
    id: t.string
  }))
});
export var BadgeProgression = t.type({
  badge: Badge,
  badgeProgress: nullable(BadgeProgress),
  earnedDate: nullable(t.string)
});
var Level = t.type({
  id: t.string,
  name: t.string
});
var LevelProgress = t.type({
  level: Level,
  earned: t["boolean"],
  earnedBadgesCount: nullable(t.number),
  requiredBadgesCount: nullable(t.number)
});
export var GetLevelsAndBadgesQuery = t.type({
  levels: t.array(LevelProgress),
  badgeProgressions: t.array(BadgeProgression)
});